import state from '~store/modules/jobs/state'
import actions from '~store/modules/jobs/actions'

export default {
  state,
  actions
}
